import { render, staticRenderFns } from "./TsscList.vue?vue&type=template&id=7160a490&scoped=true"
import script from "./TsscList.vue?vue&type=script&lang=js"
export * from "./TsscList.vue?vue&type=script&lang=js"
import style0 from "./TsscList.vue?vue&type=style&index=0&id=7160a490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160a490",
  null
  
)

export default component.exports